/**
 * Scripts
 */

import "lazysizes"
import { startupTheme } from "./js/theme"

// Import modules
// accessibility first: it applies the .reduce-motion body class that aos.js
// (and other modules) read at init to decide whether to animate.
import './js/accessibility'
import './js/aos'
import './js/slider'
import './js/toggle'
import './js/cookieBanner'
import './js/headerNav'
import './js/logoVideo'
import './js/tabs'
import './js/videoPlayer'
import './js/overlay'
import './js/newsletter'
import './js/search'
import './js/mapbox'
import './js/scrollFx'
import './js/headerScroll'
import './js/syncHeight'
import './js/calendar'
import './js/calendarOverlay'
import './js/wishlist'
import './js/teaserInview'
import './js/outboundLinks'

// Import node modules
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'

import './sass/main.sass'

if (import.meta.hot) {
  import.meta.hot.on('frontend:reload', () => location.reload())
}

/**
 * Start Theme
 */
startupTheme()
